import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { classNames, responsiveVariables } from "../../utils/helpers";
import s from './Card.module.css';
export const Card = ({ children, className, height, width, maxHeight, maxWidth, hasHoverEffect = true, attributes, }) => {
    const rootVariables = Object.assign(Object.assign(Object.assign(Object.assign({}, responsiveVariables('--st-_w', width)), responsiveVariables('--st-_h', height)), responsiveVariables('--st-_mh', maxHeight)), responsiveVariables('--st-_mw', maxWidth));
    const rootClassNames = classNames(s.root, className, width && s['--width'], hasHoverEffect && s['--hover-effect']);
    return (_jsx("div", Object.assign({ "data-testid": "st-card" }, attributes, { className: rootClassNames, style: Object.assign(Object.assign({}, attributes === null || attributes === void 0 ? void 0 : attributes.style), rootVariables), children: children })));
};
